module.exports = __webpack_public_path__ + "static/media/ipod.a3ed4d7f.jpg";